<div class="genai-container">
  <!-- Top Bar -->
  <div class="genai-topbar">
    <div class="topbar-left">
      <button class="btn-back" (click)="GoBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <div class="topbar-meta">
        <input type="text" class="input-title" [(ngModel)]="FormSchema.Name"
          placeholder="Nombre del formulario" />
        <div class="topbar-meta-row">
          <input type="text" class="input-meta" [(ngModel)]="FormSchema.Description"
            placeholder="Descripcion (opcional)" />
          <span class="meta-sep">|</span>
          <input type="text" class="input-meta input-meta-short" [(ngModel)]="FormSchema.Category"
            placeholder="Categoria (opcional)" />
        </div>
      </div>
    </div>
    <div class="topbar-right">
      <button class="btn-secondary" (click)="SaveAsDraft()" [disabled]="IsLoading">
        <i class="fa-regular fa-floppy-disk"></i> Guardar borrador
      </button>
      <button class="btn-primary" (click)="PublishTemplate()" [disabled]="IsLoading">
        <i class="fa-solid fa-paper-plane"></i> Publicar
      </button>
    </div>
  </div>

  <!-- 3-Panel Split -->
  <div class="split-pane">

    <!-- LEFT: Fields list + editor -->
    <div class="pane-fields">
      <div class="fields-panel">
        <div class="fields-header">
          <h3>Campos <span class="field-count" *ngIf="FormSchema.Fields.length > 0">({{ FormSchema.Fields.length }})</span></h3>
          <button class="btn-add-field" (click)="AddField()">
            <i class="fa-solid fa-plus"></i> Agregar
          </button>
        </div>

        <!-- Fields list -->
        <div class="fields-list" *ngIf="FormSchema.Fields.length > 0"
          cdkDropList [cdkDropListData]="FormSchema.Fields" (cdkDropListDropped)="DropField($event)">
          <div *ngFor="let field of FormSchema.Fields; let i = index" class="field-item"
            cdkDrag [class.field-active]="SelectedField === field && ShowFieldEditor">
            <div class="field-handle">
              <button class="btn-drag" cdkDragHandle title="Arrastrar campo">
                <i class="fa-solid fa-grip-vertical"></i>
              </button>
            </div>
            <div class="field-icon"><i [class]="GetFieldIcon(field.Field_Type)"></i></div>
            <div class="field-details" (click)="EditField(field, i)">
              <span class="field-label">{{ field.Label }}</span>
              <span class="field-type">{{ GetFieldTypeLabel(field.Field_Type) }}</span>
              <span *ngIf="field.Required" class="field-required">*</span>
            </div>
            <div class="field-actions">
              <button class="btn-fa" (click)="EditField(field, i)"><i class="fa-solid fa-pen"></i></button>
              <button class="btn-fa btn-fa-danger" (click)="RemoveField(i)"><i class="fa-regular fa-trash-can"></i></button>
            </div>
          </div>
        </div>

        <div *ngIf="FormSchema.Fields.length === 0" class="no-fields">
          <i class="fa-regular fa-file-lines"></i>
          <p>Usa el chat o agrega campos manualmente</p>
        </div>
      </div>

      <!-- Field Editor -->
      <div class="field-editor" *ngIf="ShowFieldEditor" @slideEditor>
        <div class="editor-accent-bar"></div>
        <div class="editor-header">
          <div class="editor-header-left">
            <div class="editor-header-icon">
              <i [class]="GetFieldIcon(FieldForm.get('Field_Type')?.value || 'text_short')"></i>
            </div>
            <div class="editor-header-text">
              <h4>{{ SelectedField ? 'Editar campo' : 'Nuevo campo' }}</h4>
              <span class="editor-header-subtitle">{{ SelectedField ? 'Modifica las propiedades del campo' : 'Configura los detalles del nuevo campo' }}</span>
            </div>
          </div>
          <button class="btn-close-editor" (click)="CancelFieldEditor()" title="Cerrar editor">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="editor-body" [formGroup]="FieldForm">

          <!-- Section: General -->
          <div class="editor-section">
            <div class="editor-section-title">
              <i class="fa-solid fa-sliders"></i>
              <span>General</span>
            </div>
            <div class="editor-row">
              <label>Tipo de campo</label>
              <p-select [options]="FieldTypes" optionLabel="label" optionValue="value"
                formControlName="Field_Type" placeholder="Selecciona un tipo" styleClass="w-full">
              </p-select>
            </div>
            <div class="editor-row">
              <label>Etiqueta <span class="required-asterisk">*</span></label>
              <input type="text" pInputText formControlName="Label" placeholder="Nombre del campo" />
            </div>
            <div class="editor-row" *ngIf="FieldForm.get('Field_Type')?.value !== 'section' && FieldForm.get('Field_Type')?.value !== 'boolean' && FieldForm.get('Field_Type')?.value !== 'table' && FieldForm.get('Field_Type')?.value !== 'signature'">
              <label>Placeholder</label>
              <input type="text" pInputText formControlName="Placeholder" placeholder="Texto de ayuda" />
            </div>
            <div class="editor-row" *ngIf="FieldForm.get('Field_Type')?.value !== 'section' && FieldForm.get('Field_Type')?.value !== 'boolean' && FieldForm.get('Field_Type')?.value !== 'table' && FieldForm.get('Field_Type')?.value !== 'file' && FieldForm.get('Field_Type')?.value !== 'image' && FieldForm.get('Field_Type')?.value !== 'signature'">

              <label>Valor por defecto</label>
              
              <!-- Text types -->
              <input *ngIf="FieldForm.get('Field_Type')?.value === 'text_short' || FieldForm.get('Field_Type')?.value === 'text_long' || FieldForm.get('Field_Type')?.value === 'qr_code' || FieldForm.get('Field_Type')?.value === 'barcode'" 
                type="text" pInputText formControlName="Default_Value" placeholder="Valor inicial" />

              
              <!-- Email -->
              <input *ngIf="FieldForm.get('Field_Type')?.value === 'email'" 
                type="email" pInputText formControlName="Default_Value" placeholder="correo@ejemplo.com" />
              
              <!-- Phone -->
              <input *ngIf="FieldForm.get('Field_Type')?.value === 'phone'" 
                type="tel" pInputText formControlName="Default_Value" placeholder="+34 123 456 789" />
              
              <!-- URL -->
              <input *ngIf="FieldForm.get('Field_Type')?.value === 'url'" 
                type="url" pInputText formControlName="Default_Value" placeholder="https://ejemplo.com" />
              
              <!-- Number -->
              <input *ngIf="FieldForm.get('Field_Type')?.value === 'number'" 
                type="number" pInputText formControlName="Default_Value" placeholder="0" />
              
              <!-- Date -->
              <p-datePicker *ngIf="FieldForm.get('Field_Type')?.value === 'date'" 
                formControlName="Default_Value" dateFormat="dd/mm/yy"></p-datePicker>
              
              <!-- Time -->
              <input *ngIf="FieldForm.get('Field_Type')?.value === 'time'" 
                type="time" pInputText formControlName="Default_Value" />
              
              <!-- Rich Text -->
              <textarea *ngIf="FieldForm.get('Field_Type')?.value === 'rich_text'" 
                pInputTextarea formControlName="Default_Value" placeholder="Contenido inicial" rows="3"></textarea>
              
              <!-- Select / Multi-select / Checkbox List -->
              <input *ngIf="FieldForm.get('Field_Type')?.value === 'select' || FieldForm.get('Field_Type')?.value === 'multi_select' || FieldForm.get('Field_Type')?.value === 'checkbox_list'" 
                type="text" pInputText formControlName="Default_Value" placeholder="Separar múltiples valores con comas" />
            </div>
            <div class="editor-row" *ngIf="FieldForm.get('Field_Type')?.value === 'section'">
              <label>Nombre de sección</label>
              <input type="text" pInputText formControlName="Section_Name" placeholder="Nombre de la sección" />
            </div>
          </div>

          <!-- Section: Options -->
          <div class="editor-section"
            *ngIf="FieldForm.get('Field_Type')?.value === 'select' || FieldForm.get('Field_Type')?.value === 'multi_select' || FieldForm.get('Field_Type')?.value === 'checkbox_list'">
            <div class="editor-section-title">
              <i class="fa-solid fa-list-check"></i>
              <span>Opciones</span>
            </div>
            <div class="editor-row">
              <label>Opciones disponibles <span class="label-hint">(una por línea)</span></label>
              <textarea pTextarea formControlName="Options" rows="4"
                placeholder="Opción 1&#10;Opción 2&#10;Opción 3"></textarea>
            </div>
          </div>

          <!-- Section: Table columns -->
          <div class="editor-section" *ngIf="FieldForm.get('Field_Type')?.value === 'table'">
            <div class="editor-section-title">
              <i class="fa-solid fa-table-columns"></i>
              <span>Columnas de la tabla</span>
            </div>
            <div class="table-columns-section">
              <div *ngFor="let col of TableColumns; let ci = index" class="table-column-row">
                <div class="col-index">{{ ci + 1 }}</div>
                <input type="text" pInputText [(ngModel)]="col.name" [ngModelOptions]="{standalone: true}"
                  placeholder="Nombre de columna" class="col-name-input" (change)="SyncTableColumnsToOptions()" />
                <p-select [options]="ColumnTypeOptions" optionLabel="label" optionValue="value"
                  [(ngModel)]="col.type" [ngModelOptions]="{standalone: true}"
                  (onChange)="SyncTableColumnsToOptions()" styleClass="col-type-select">
                </p-select>
                <button type="button" class="col-remove-btn" (click)="RemoveTableColumn(ci)"
                  [disabled]="TableColumns.length <= 1" title="Eliminar columna">
                  <i class="fa-regular fa-trash-can"></i>
                </button>
              </div>
              <button type="button" class="col-add-btn" (click)="AddTableColumn()">
                <i class="fa-solid fa-plus"></i> Agregar columna
              </button>
            </div>
          </div>

          <!-- Required toggle -->
          <div class="editor-toggle-row" *ngIf="FieldForm.get('Field_Type')?.value !== 'section'">
            <div class="toggle-info">
              <i class="fa-solid fa-asterisk"></i>
              <div>
                <span class="toggle-label">Campo obligatorio</span>
                <span class="toggle-desc">El usuario deberá completar este campo</span>
              </div>
            </div>
            <label class="toggle-switch">
              <input type="checkbox" formControlName="Required" />
              <span class="toggle-slider"></span>
            </label>
          </div>

          <!-- Section: Validations -->
          <div class="editor-section"
            *ngIf="FieldForm.get('Field_Type')?.value === 'text_short' || FieldForm.get('Field_Type')?.value === 'text_long' || FieldForm.get('Field_Type')?.value === 'number'">
            <div class="editor-section-title">
              <i class="fa-solid fa-shield-check"></i>
              <span>Validaciones</span>
            </div>
            <div class="editor-row" *ngIf="FieldForm.get('Field_Type')?.value === 'text_short' || FieldForm.get('Field_Type')?.value === 'text_long'">
              <label>Min / Max caracteres</label>
              <div class="row-inline">
                <input type="number" pInputText formControlName="Val_MinLength" placeholder="Mínimo" />
                <input type="number" pInputText formControlName="Val_MaxLength" placeholder="Máximo" />
              </div>
            </div>
            <div class="editor-row" *ngIf="FieldForm.get('Field_Type')?.value === 'number'">
              <label>Valor min / max</label>
              <div class="row-inline">
                <input type="number" pInputText formControlName="Val_Min" placeholder="Mínimo" />
                <input type="number" pInputText formControlName="Val_Max" placeholder="Máximo" />
              </div>
            </div>
            <div class="editor-row" *ngIf="FieldForm.get('Field_Type')?.value === 'text_short'">
              <label>Patrón (regex)</label>
              <input type="text" pInputText formControlName="Val_Pattern" placeholder="^[A-Z]+" />
            </div>
          </div>

          <!-- Section: Email/Phone/URL Options -->
          <div class="editor-section" 
            *ngIf="FieldForm.get('Field_Type')?.value === 'phone' || FieldForm.get('Field_Type')?.value === 'url'">
            <div class="editor-section-title">
              <i class="fa-solid fa-sliders"></i>
              <span>Patrón de validación</span>
            </div>
            <div class="editor-row">
              <label>Patrón (regex)</label>
              <input type="text" pInputText formControlName="Val_Pattern" 
                placeholder="Ej: ^\+?[0-9\s\-\(\)]{10,}" />
            </div>
          </div>

          <!-- Section: Time/Date Options -->
          <div class="editor-section" 
            *ngIf="FieldForm.get('Field_Type')?.value === 'time'" >
            <div class="editor-section-title">
              <i class="fa-solid fa-clock"></i>
              <span>Configuración de Hora</span>
            </div>
            <div class="editor-row label-hint">
              <i class="fa-solid fa-info-circle"></i>
              <span>El campo aceptará horas en formato HH:mm</span>
            </div>
          </div>

          <!-- Section: Rich Text Options -->
          <div class="editor-section" 
            *ngIf="FieldForm.get('Field_Type')?.value === 'rich_text'" >
            <div class="editor-section-title">
              <i class="fa-solid fa-pen-nib"></i>
              <span>Opciones de Formato</span>
            </div>
            <div class="editor-row label-hint">
              <i class="fa-solid fa-info-circle"></i>
              <span>Los usuarios podrán usar negritas, itálicas, listas y más</span>
            </div>
          </div>

          <!-- Section: QR/Barcode -->
          <div class="editor-section" 
            *ngIf="FieldForm.get('Field_Type')?.value === 'qr_code' || FieldForm.get('Field_Type')?.value === 'barcode'" >
            <div class="editor-section-title">
              <i class="fa-solid fa-qrcode"></i>
              <span>Configuración de Escaneo</span>
            </div>
            <div class="editor-row label-hint">
              <i class="fa-solid fa-info-circle"></i>
              <span>Los usuarios podrán escanear códigos con su dispositivo</span>
            </div>
          </div>

          <!-- Actions -->
          <div class="editor-actions">
            <button class="btn-editor-save" (click)="SaveField()">
              <i class="fa-solid fa-check"></i> {{ SelectedField ? 'Guardar cambios' : 'Agregar campo' }}
            </button>
            <button class="btn-editor-cancel" (click)="CancelFieldEditor()">
              <i class="fa-solid fa-xmark"></i> Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- CENTER: Preview -->
    <div class="pane-preview">
      <div class="preview-header"><span>Vista previa</span></div>
      <div class="preview-body">
        <div *ngIf="FormSchema.Fields.length > 0" class="preview-form">
          <div class="preview-title">{{ FormSchema.Name || 'Sin nombre' }}</div>
          <app-form-fill-cdms [fields]="FormSchema.Fields" [mode]="'preview'"></app-form-fill-cdms>
        </div>
        <div *ngIf="FormSchema.Fields.length === 0 && !IsLoading" class="preview-empty">
          <ng-container *ngIf="!SelectedFile">
            <button class="upload-btn-large" (click)="TriggerFileUpload()">
              <i class="fa-solid fa-cloud-arrow-up"></i>
              <span>Upload and edit</span>
            </button>
            <p>Sube un documento o describe lo que necesitas en el chat</p>
          </ng-container>

          <ng-container *ngIf="SelectedFile">
            <div class="file-loaded-large">
              <div class="icon-wrap">
                <i class="fa-solid fa-file-circle-check"></i>
              </div>
              <span class="file-name">{{ SelectedFile.name }}</span>
              <span class="file-size">{{ (SelectedFile.size / 1024).toFixed(1) }} KB</span>
              <p style="font-size: 11px; color: #888; margin-top: 10px;">Documento listo. Envía instrucciones por el chat para procesarlo.</p>
              <button class="btn-remove-large" (click)="RemoveFile()" title="Quitar archivo">
                <i class="fa-solid fa-trash-can"></i>
              </button>
            </div>
          </ng-container>
        </div>

        <div *ngIf="IsLoading && FormSchema.Fields.length === 0" class="preview-loading">
          <div class="spinner"></div>
          <p>La IA esta procesando...</p>
        </div>
      </div>
    </div>

    <!-- RIGHT: Chat -->
    <div class="pane-chat">
      <div class="chat-header"><span>Chat</span></div>
      <div class="chat-messages" #chatMessages>
        <div class="chat-date">{{ ChatHistory[0]?.timestamp | date:'longDate' }}</div>
        <div *ngFor="let msg of ChatHistory" class="chat-bubble"
          [ngClass]="{'bubble-user': msg.role === 'user', 'bubble-assistant': msg.role === 'assistant'}">
          <div class="bubble-content">{{ msg.content }}</div>
        </div>
        <div *ngIf="IsLoading" class="chat-bubble bubble-assistant">
          <div class="bubble-content typing">
            <span class="dot"></span><span class="dot"></span><span class="dot"></span>
          </div>
        </div>
      </div>
      <div class="chat-input-area">
        <div *ngIf="SelectedFile" class="file-attachment">
          <i class="fa-solid fa-file"></i>
          <span>{{ SelectedFile.name }}</span>
          <button class="btn-remove-file" (click)="RemoveFile()"><i class="fa-solid fa-xmark"></i></button>
        </div>
        <div class="chat-input-row">
          <textarea [(ngModel)]="UserInput" (keydown)="OnKeyDown($event)"
            placeholder="Add instructions..." rows="1" class="chat-textarea" [disabled]="IsLoading"></textarea>
          <div class="chat-input-actions">
            <button class="input-action-btn" (click)="TriggerFileUpload()" title="Adjuntar"><i class="fa-solid fa-paperclip"></i></button>
            <button class="input-action-btn btn-send" (click)="SendMessage()"
              [disabled]="IsLoading || (!UserInput.trim() && !SelectedFile)"><i class="fa-solid fa-arrow-up"></i></button>
          </div>
        </div>
      </div>
      <input type="file" #fileInput (change)="OnFileSelect($event)" accept=".pdf,.png,.jpg,.jpeg,.gif,.webp" style="display:none" />
    </div>

  </div>
</div>
